import React from "react";
import { Link } from "react-router-dom";

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

const getLinkTarget = (url) => {
  try {
    const parsed = new URL(url);
    if (parsed.origin === window.location.origin) {
      return {
        internal: true,
        to: `${parsed.pathname}${parsed.search}${parsed.hash}`,
      };
    }
    return { internal: false, href: url };
  } catch {
    return { internal: false, href: url };
  }
};

export function renderMessageText(text) {
  if (!text || typeof text !== "string") return text;
  if (!/(https?:\/\/)/.test(text)) return text;

  URL_PATTERN.lastIndex = 0;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = URL_PATTERN.exec(text)) !== null) {
    const url = match[0];
    const start = match.index;

    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }

    const target = getLinkTarget(url);
    if (target.internal) {
      parts.push(
        <Link
          key={`message-link-${start}`}
          to={target.to}
        >
          {url}
        </Link>,
      );
    } else {
      parts.push(
        <a
          key={`message-link-${start}`}
          href={target.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>,
      );
    }

    lastIndex = start + url.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length === 1 && typeof parts[0] === "string" ? parts[0] : parts;
}
